var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.375,
    height: 111.375,
    viewBox: "0 0 111.375 111.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M59.063,3.375A55.688,55.688,0,1,0,114.75,59.063,55.679,55.679,0,0,0,59.063,3.375ZM73.172,79.222,59.063,65.113,44.953,79.222A4.278,4.278,0,1,1,38.9,73.172L53.012,59.063,38.9,44.953A4.278,4.278,0,0,1,44.953,38.9L59.062,53.012,73.172,38.9a4.278,4.278,0,1,1,6.051,6.051L65.113,59.063,79.222,73.172a4.3,4.3,0,0,1,0,6.051A4.25,4.25,0,0,1,73.172,79.222Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGrey);
export default __webpack_public_path__ + "static/media/icon_close_grey.1928a4a4.svg";
export { ForwardRef as ReactComponent };